import CapitalGrowth from "./pages/CapitalGrowth";
import StatementOfAccount from "./pages/StatementOfAccount";
import EMIPaidReport from "./pages/EMIPaidReport";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { SettingsProvider } from "@/context/SettingsContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Accounts from "@/pages/Accounts";
import FirstPasswordChange from "@/pages/FirstPasswordChange";
import Dashboard from "@/pages/Dashboard";
import Documents from "@/pages/Documents";
import Customers from "@/pages/Customers";
import CustomerProfile from "@/pages/CustomerProfile";
import LoanDetail from "@/pages/LoanDetail";
import Reports from "@/pages/Reports";
import LoanMonthlySummary from "@/pages/LoanMonthlySummary";
import BalanceSheet from "@/pages/BalanceSheet";
import Expenses from "@/pages/Expenses";
import Settings from "@/pages/Settings";
import BusinessProfile from "@/pages/BusinessProfile";
import OverdueCustomers from "@/components/OverdueCustomers";
function Protected({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-navy font-heading">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (user.must_change_password) return <Navigate to="/change-password" replace />;
  if (user.role === "collector" && location.pathname === "/") return <Navigate to="/customers" replace />;
  return children;
}
function App() {
  return <div className="App"><AuthProvider><SettingsProvider><BrowserRouter>
    <Toaster position="top-right" richColors />
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/change-password" element={<FirstPasswordChange />} />
      <Route element={<Protected><Layout /></Protected>}>
        <Route path="/" element={<Dashboard />} />
        <Route path="/accounts" element={<Accounts />} />
        <Route path="/customers" element={<Customers />} />
        <Route path="/overdue-customers" element={<OverdueCustomers />} />
        <Route path="/customers/:id" element={<CustomerProfile />} />
        <Route path="/loans/:id" element={<LoanDetail />} />
        <Route path="/statement-of-account" element={<StatementOfAccount />} />
        <Route path="/capital-growth" element={<CapitalGrowth />} />
        <Route path="/reports" element={<Reports />} />
        <Route path="/loan-monthly-summary" element={<LoanMonthlySummary />} />
        <Route path="/balance-sheet" element={<BalanceSheet />} />
        <Route path="/emi-paid" element={<EMIPaidReport />} />
        <Route path="/documents" element={<Documents />} />
        <Route path="/expenses" element={<Expenses />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/business-profile" element={<BusinessProfile />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  </BrowserRouter></SettingsProvider></AuthProvider></div>;
}
export default App;
